const STATS = [
  { value: "3", unit: "年", label: "持续运营时长" },
  { value: "1200", unit: "+", label: "深度盘点内容" },
  { value: "98", unit: "%", label: "公开素材溯源率" },
  { value: "24", unit: "h", label: "最快更正响应" },
];

const PRINCIPLES = [
  {
    icon: "ri-list-check-3",
    title: "客观还原，讲清脉络",
    desc: "以逐小时时间线替代碎片化转发，让事件从发生到回应的每一步都清楚可查。",
  },
  {
    icon: "ri-shield-check-line",
    title: "隐私优先，有界可依",
    desc: "不收录未经同意的聊天记录与录音，所有内容以不侵犯隐私与名誉权为前提。",
  },
  {
    icon: "ri-error-warning-line",
    title: "及时更正，敢于负责",
    desc: "判定性表述以公开证据为准，收到权利人指正后 24 小时内核实并处理。",
  },
];

const QUOTES = [
  {
    text: "第一次能在十分钟内把一整个事件从头捋到尾，时间线写法真的太友好了。",
    name: "常读用户 · 林先生",
    tag: "关注娱乐圈资讯 2 年",
  },
  {
    text: "以前总被各种营销号带偏，这里会保留多方说法，把判断权还给我，很踏实。",
    name: "常读用户 · 陈同学",
    tag: "大学生 · 音综爱好者",
  },
  {
    text: "更正响应特别快，之前一篇的措辞有歧义，发邮件后当天就收到了说明。",
    name: "常读用户 · 周女士",
    tag: "新媒体从业者",
  },
];

export default function BrandAbout() {
  return (
    <section id="about" className="w-full bg-background-50 py-12 md:py-16" aria-label="关于我们">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
          <div>
            <span className="text-xs font-bold tracking-[0.2em] text-accent-600">ABOUT · 关于我们</span>
            <h2 className="mt-2 font-heading text-3xl font-black leading-tight text-foreground-950 md:text-4xl">
              让每一次吃瓜，
              <br />
              都有据可循、有界可依
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              吃瓜嘿料诞生于一个朴素的想法：网上信息太碎、转发太快、断章太易，缺的不是热闹，而是把一件事讲清楚的能力。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              我们把自己定位成“信息整理者”而非“爆料者”：把散落在各平台、符合公共知情需要的图文与官方回应，按时间线与信源口径归拢成内容。我们不虚构结论，不收录涉及隐私的私聊与录音，并承诺对错误第一时间更正。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              三年走来，我们把“核实—整理—再核实”写进了每天的工作流，也把“让读者自己判断”当作最高原则。因为真正的吃瓜自由，不是跟着谁的情绪跑，而是站在足够完整的信息前，自己拿主意。
            </p>
          </div>

          <div className="grid grid-cols-2 content-start gap-4">
            {STATS.map((s) => (
              <div key={s.label} className="rounded-2xl border border-background-200 bg-background-100 p-6">
                <p className="font-heading text-3xl font-black text-accent-600 md:text-4xl">
                  {s.value}
                  <span className="text-2xl">{s.unit}</span>
                </p>
                <p className="mt-2 text-sm font-medium text-foreground-600">{s.label}</p>
              </div>
            ))}
            <div className="col-span-2 flex items-center gap-3 rounded-2xl border border-accent-200 bg-accent-100/60 p-5">
              <i className="ri-focus-3-line text-2xl text-accent-700" aria-hidden="true"></i>
              <p className="text-sm leading-relaxed text-accent-900">
                内容原则不因流量改变：宁可少一条，也不错一条；宁可慢半拍，也不跑偏。
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-3">
          {PRINCIPLES.map((p) => (
            <div key={p.title} className="rounded-2xl border border-background-200 bg-background-50 p-6">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-100 text-primary-700">
                <i className={`text-xl ${p.icon}`} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{p.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-12">
          <div className="flex items-end justify-between">
            <div>
              <span className="text-xs font-bold tracking-[0.2em] text-primary-600">VOICE · 读者口碑</span>
              <h3 className="mt-2 font-heading text-2xl font-black text-foreground-950">他们说</h3>
            </div>
            <i className="ri-double-quotes-r hidden text-5xl text-background-300 sm:block" aria-hidden="true"></i>
          </div>
          <div className="mt-6 grid grid-cols-1 gap-5 md:grid-cols-3">
            {QUOTES.map((q) => (
              <figure key={q.name} className="rounded-2xl border border-background-200 bg-background-100 p-6">
                <p className="text-sm leading-relaxed text-foreground-700">“{q.text}”</p>
                <figcaption className="mt-4 flex items-center gap-3 border-t border-background-200 pt-4">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-500 font-heading text-sm font-bold text-background-50">
                    {q.name.slice(-2, -1)}
                  </span>
                  <div>
                    <p className="text-sm font-bold text-foreground-900">{q.name}</p>
                    <p className="text-xs text-foreground-500">{q.tag}</p>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}